function LazyHammer(element, options = {}) {
  return import('bower/hammerjs/hammer.min.js').then(() => {
    return window.Hammer(element, options);
  });
}

export default LazyHammer;
